import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// Axios Request
import { fetchSinglePost } from '../requests/singlepost_request';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Loader from '../components/Loader';

import RenderSingle from '../components/Pages/RenderSingle';

class SinglePage extends Component {
    state = {
        location: '',
        previewPost: false,
    };
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentWillMount() {
        this.getPosts(this.props, true);

        let path = this.props.location.pathname;
        let stringOfPath = path.replace(/\//g, ' ');

        this.setState({
            location: stringOfPath,
        });
    }

    componentWillReceiveProps(nextProps) {
        this.getPosts(nextProps);
    }

    getPosts(props, willMount = false) {
        let slug = this.props.location.pathname;
        slug = slug.substring(1);

        if (willMount) {
            this.props.fetchSinglePost('pages', slug);
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.posts.fetched) {
            if (nextProps.posts.posts[0]) {
                document.title = `${nextProps.posts.posts[0].title.rendered} - Friends for Brands`;
            } else {
                document.title = `Page not found - Friends for Brands`;
            }
        }
    }

    render() {
        return (
            <div className="single page">
                <Header />
                {this.props.posts.fetched === false &&
                    this.props.posts.failed === false && (
                        <div>
                            <Loader />
                        </div>
                    )}
                {this.props.posts.failed && (
                    <main>
                        <div id="main-container">
                            <div className="content-container">
                                <Loader loaded={this.props.posts.fetched} />
                                {this.props.posts.fetched ? (
                                    <div className="fadeIn">
                                        <h1>4.0.4</h1>
                                        <h2>
                                            Oops. This page doesn’t seem to
                                            exist
                                        </h2>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <Footer name={this.props.name} />
                    </main>
                )}
                {this.props.posts.fetched && !this.props.posts.posts[0] && (
                    <main>
                        <div id="main-container">
                            <div className="content-container">
                                <Loader loaded={this.props.posts.fetched} />
                                {this.props.posts.fetched ? (
                                    <div className="fadeIn">
                                        <h1>4.0.4</h1>
                                        <h2>
                                            Oops. This page doesn’t seem to
                                            exist
                                        </h2>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <Footer name={this.props.name} />
                    </main>
                )}
                {this.props.posts.fetched && this.props.posts.posts[0] && (
                    <main>
                        <div id="main-container">
                            <div className="content-container">
                                <Loader loaded={this.props.posts.fetched} />
                                {this.props.posts.fetched ? (
                                    <div className="fadeIn">
                                        <RenderSingle
                                            posts={this.props.posts}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <Footer />
                    </main>
                )}
            </div>
        );
    }
}

function mapStateToProps({ posts }) {
    return { posts };
}

export default withRouter(
    connect(mapStateToProps, { fetchSinglePost })(SinglePage)
);



// WEBPACK FOOTER //
// ./src/containers/SinglePage.jsx